const BACKSPACE = 8;
const TAB = 9;
const DELETE = 46;

export const expiredDateKey = "expired-date";
export const mfaMaxPushNotifStatusKey = "mfa-max-push-notif-status";
export const mfaMaxPushNotifCountdownStatusKey =
  "mfa-max-notif-countdown-status";
export const pushApprovalCounterKey = "push-approval-counter";

export const handleKeydown = (e) => {
  const isArrowKey = e.key === "ArrowLeft" || e.key === "ArrowRight";
  const isSpace = e.key === " " || e.code === "Space";
  const isBackSpace = e.keyCode === BACKSPACE || e.key === "Backspace";
  const isDelete = e.keyCode === DELETE || e.key === "Delete";
  const isTab = e.keyCode === TAB || e.key === "Tab";
  if (isArrowKey || isSpace || isBackSpace || isDelete || isTab) {
    e.preventDefault();
  }
};

export const removeMfaSessions = () => {
  sessionStorage.removeItem(pushApprovalCounterKey);
  sessionStorage.removeItem(expiredDateKey);
  sessionStorage.removeItem(mfaMaxPushNotifStatusKey);
  sessionStorage.removeItem(mfaMaxPushNotifCountdownStatusKey);
};
